import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LOGIN_REQUEST } from "../../Utils/Constant";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Login = ({ onForgotPassword }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, isAuthenticated } = useSelector(
    (state) => state.auth
  );

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    role: "super_admin",
  });
  const [showPassword, setShowPassword] = useState(false);
  const emailRef = useRef(null);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/");
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  useEffect(() => {
    if (isAuthenticated) {
      toast.success("Login successful!");
      navigate("/");
    }
  }, [isAuthenticated]);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRoleChange = (e) => {
    setFormData(prev => ({ ...prev, role: e.target.value }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch({ type: LOGIN_REQUEST, payload: formData });
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "1rem",
      }}
    >
      <div
        className="card shadow-lg"
        style={{
          maxWidth: 420,
          width: "100%",
          borderRadius: "1rem",
          padding: "2rem",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
        }}
      >
        <h2
          className="card-title text-center mb-4 fw-bold"
          style={{ color: "#333" }}
        >
          Welcome Back
        </h2>
        <form onSubmit={handleSubmit}>
        <div className="mb-4 position-relative">
            <label className="form-label fw-semibold">Login as</label>
            <select className="form-select" name="role" value={formData.role} onChange={handleRoleChange}>
              <option value="super_admin">Super Admin</option>
              <option value="hotel_admin">Hotel Admin</option>
              <option value="staff">Staff</option>
            </select>
          </div>

          <div className="mb-4 position-relative">
            <label htmlFor="email" className="form-label fw-semibold">
              Email
            </label>
            <div className="input-group">
              <span
                className="input-group-text bg-white border-end-0"
                style={{ borderRadius: "0.375rem 0 0 0.375rem" }}
              >
                <FiMail size={18} color="#555" />
              </span>
              <input
                id="email"
                name="email"
                type="email"
                className="form-control border-start-0"
                placeholder="your.email@example.com"
                value={formData.email}
                onChange={handleChange}
                ref={emailRef}
                required
                style={{ borderRadius: "0 0.375rem 0.375rem 0" }}
              />
            </div>
          </div>

          <div className="mb-4 position-relative">
            <label htmlFor="password" className="form-label fw-semibold">
              Password
            </label>
            <div className="input-group">
              <span
                className="input-group-text bg-white border-end-0"
                style={{ borderRadius: "0.375rem 0 0 0.375rem" }}
              >
                <FiLock size={18} color="#555" />
              </span>
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                className="form-control border-start-0"
                placeholder="Enter your password"
                value={formData.password}
                onChange={handleChange}
                required
                style={{ borderRadius: "0 0.375rem 0.375rem 0" }}
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="btn btn-outline-secondary border-start-0"
                style={{
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  borderTopRightRadius: "0.375rem",
                  borderBottomRightRadius: "0.375rem",
                  padding: "0.375rem 0.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                tabIndex={-1}
              >
                {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn w-100 py-2 fw-bold"
            disabled={loading}
            style={{
              fontSize: "1.1rem",
              borderRadius: "0.75rem",
              letterSpacing: "0.05em",
              backgroundColor: "#000",
              color: "#fff",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.4)",
              transition: "background-color 0.3s ease",
              border: "none",
            }}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {/* <div className="mt-4 text-center">
          <button
            className="btn btn-link text-decoration-none"
            onClick={onForgotPassword}
            type="button"
            style={{ fontWeight: "600", color: "#764ba2" }}
          >
            Forgot Password?
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Login;
